const CLASS_NAME = {
  'wrapper': 'form-group form-availability-timetable__slot',
  'input': 'form__radio--tag',
  // States
  'available': 'form__radio--outline',
  'unavailable': 'form__radio--muted',
  'past': 'form__radio--disabled'
};

// Output:
// <div class="form-group form-availability-timetable__slot">
//    <input id="slot-1525982400"
//           name="slot"
//           type="radio"
//           value="1525982400"
//           class="form__radio--tag form__radio--outline">
//    <label for="slot-1525982400">20:00</label>
// </div>
const TimetableSlot = ({ inputName, time, timestamp, isPast, isAvailable }) => {
  let slotId = `slot-${timestamp}`;
  let slotElement = document.createElement('div');
  slotElement.setAttribute('class', CLASS_NAME['wrapper']);

  let inputElement = document.createElement('input');
  let inputClassName = [CLASS_NAME['input']];
  isPast && inputClassName.push(CLASS_NAME['past']);
  (!isPast && isAvailable) && inputClassName.push(CLASS_NAME['available']);
  !isAvailable && inputClassName.push(CLASS_NAME['unavailable']);

  inputElement.setAttribute('type', 'radio');
  inputElement.setAttribute('name', inputName);
  inputElement.setAttribute('value', timestamp);
  inputElement.setAttribute('id', slotId);
  inputElement.setAttribute('class', inputClassName.join(' '));
  (isPast || !isAvailable) && inputElement.setAttribute('disabled', 'disabled');

  let labelElement = document.createElement('label');
  labelElement.setAttribute('for', slotId);
  labelElement.innerText = time;

  slotElement.appendChild(inputElement);
  slotElement.appendChild(labelElement);

  return slotElement;
};

export default TimetableSlot;



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/availabilityTimetableForm/timetableSlot.js